export class Cache<T> {
  private readonly values: Record<string, T> = {};
  private allValues: Array<[string, T]> = [];

  public constructor(private maxNumberOfValues: number) {}

  public get(key: string): T | undefined {
    const value = this.values[key];

    return value;
  }

  public insert(key: string, value: T): void {
    if (this.allValues.length >= this.maxNumberOfValues) {
      if (this.allValues[0]) {
        this.evict(this.allValues[0][0]);
      }
      this.allValues = this.allValues.slice(1);
    }

    this.allValues.push([key, value]);
    this.values[key] = value;
  }

  private evict(key: string): void {
    delete this.values[key];
  }
}
